let variantId = '40380090679330';

const shippingInsuranceVariants = {
  '0-25': 40380090679330, // '$0.50',
  '26-35': 40380090712098, // '$0.67',
  '36-45': 40380090744866, // '$0.88',
  '46-55': 40380090777634, // '$1.09',
  '56-65': 40380090810402, // '$1.31',
  '66-75': 40380090843170, // '$1.52',
  '76-85': 40380090875938, // '$1.74',
  '86-95': 40380090908706, // '$1.95',
  '96-100': 40380090941474, // '$2.11',
  '101-110': 40380090974242, // '$2.27',
  '111-120': 40380091007010, // '$2.49',
  '121-130': 40380091039778, // '$2.71',
  '131-140': 40380091072546, // '$2.93',
  '141-150': 40380091105314, // '$3.13',
  '151-160': 40380091138082, // '$3.36',
  '161-170': 40380091170850, // '$3.57',
  '171-180': 40380091203618, // '$3.79',
  '181-190': 40380091236386, // '$4.01',
  '191-200': 40380091269154, // '$4.21',
  '201-225': 40380091301922, // '$4.58',
  '226-250': 40380091334690, // '$5.12',
  '251-275': 40380091367458, // '$5.66',
  '276-300': 40380091400226, // '$6.19',
  '301-350': 40380091432994, // '$6.98',
  '351-400': 40380091465762, // '$8.06',
  '401-450': 40380091498530, // '$9.16',
  '451-500': 40380091531298, // '$10.23',
  '500-600': 40380091564066, // '$11.82',
  '600-700': 40380091596834, // '$13.98',
  '700-800': 40380091629602, // '$16.13',
  '800-900': 40380091662370, // '$18.28',
  '900-1000': 40380091695138, // '$20.43',
  '1000-2000': 40380091727906, // '$32.25',
  '2000-': 40380091760674, // '$52.50',
};

function showLoadingOverlay(loadingOverlay) {
    console.log('showLoadingOverlay');
    console.log(loadingOverlay);

    const checkOverlayExists = setInterval(function () {
        if (loadingOverlay !== null) {
            loadingOverlay.style.display = "flex";
            clearInterval(checkOverlayExists);
        }
    }, 100);
}

function removeShippingInsurance() {
  let updatesBody = {};

  for (variant in shippingInsuranceVariants) {
    updatesBody[shippingInsuranceVariants[variant]] = 0;
  }

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      updates: updatesBody
    })
  })
  .then(response => {
    return response.json();
  })
  .then(res => {
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function addShippingInsurance(isCheckBox = false) {

  fetch('/cart.json', {
    credentials: 'same-origin',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    },
  })
  .then(function (response) {
    response.json().then(function (content) {
      cartData = content;
      for (variant in shippingInsuranceVariants) {
        minPrice = parseInt(variant.split('-')[0]) * 100;
        maxPrice = parseInt(variant.split('-')[1]) * 100;

        if (minPrice <= cartData.original_total_price && maxPrice >= cartData.original_total_price) {
          variantId = shippingInsuranceVariants[variant];
        }
      }

      // add item and redirect
      let formData = {};
      const checkBox = document.getElementById('check_shipping_insurance');
      const loadingOverlay = document.getElementById("js:loader");

      if (checkBox.checked) {
        formData = {
          'items': [{
            'id': variantId,
            'quantity': 1,
          }]
        };
      }

      fetch('/cart/add.js', {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {      
        return response.json();
      })
      .then(res => {
        if (!isCheckBox) {
          setTimeout(function () {
            window.location.href = "/checkout";
            showLoadingOverlay(loadingOverlay);
          }, 100);
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });

    });
  })

}

function handleShippingInsuranceCheck() {
  const checkBox = document.getElementById('check_shipping_insurance');

  if (!checkBox) return;

  if (checkBox.checked) {
    addShippingInsurance(true);
  } else {
    removeShippingInsurance();  
  }
}

function init() {
  
    document.addEventListener('click', function (e) {

        // click checkout
        if (e.target.id == 'js:checkout'){
            e.preventDefault();
            addShippingInsurance();  
        }

  }, false);

  removeShippingInsurance();
}

init();